import {GeneralLedgerAccountSummaryApiDto} from "../../api/model/rest";
import GeneralLedgerSummary from "./GeneralLedgerSummary";

export default class GeneralLedgerAccountSummary {

	constructor(public readonly name: string,
		public readonly summary: GeneralLedgerSummary) {}

	static fromJson(json: GeneralLedgerAccountSummaryApiDto): GeneralLedgerAccountSummary {
		const summary = GeneralLedgerSummary.fromJson(json.summary);
		return new GeneralLedgerAccountSummary(json.name, summary);
	}
}
